import img from './img';

const flag = (code) => img(`/static/images/flags/${code}.svg`, 'c-flag icon', code);

export default flag;
